// Per-task time-tracking API wrappers (tasks-clickup-overhaul P3).

import { api } from "../lib/api";
import type { TaskTimeSummary, TimeEntry } from "@juuplan/shared";

export function fetchTaskTime(taskId: number): Promise<TaskTimeSummary> {
  return api<TaskTimeSummary>(`/api/tasks/${taskId}/time`);
}

export function startTimer(taskId: number): Promise<TimeEntry> {
  return api<TimeEntry>(`/api/tasks/${taskId}/time/start`, { method: "POST", body: {} });
}

export function stopTimer(taskId: number): Promise<TimeEntry> {
  return api<TimeEntry>(`/api/tasks/${taskId}/time/stop`, { method: "POST", body: {} });
}

export function addManualTime(
  taskId: number,
  durationMinutes: number,
  note?: string | null
): Promise<TimeEntry> {
  return api<TimeEntry>(`/api/tasks/${taskId}/time`, {
    method: "POST",
    body: { duration_minutes: durationMinutes, note: note ?? null },
  });
}

export function deleteTimeEntry(taskId: number, entryId: number): Promise<void> {
  return api(`/api/tasks/${taskId}/time/${entryId}`, { method: "DELETE" }) as unknown as Promise<void>;
}
